//import axios from "axios"
import axios, { AxiosRequestConfig, AxiosRequestHeaders } from 'axios'
import Cookies from "universal-cookie"
import { jwtDecode } from 'jwt-decode'
import logout from "../_helper/_logout"
import { setCookies } from "../components/_helper/cookies"

interface JwtPayload {
    _id?: string
    id?: string
    sub?: string
}

const cookies = new Cookies()

/**
 * Default instance for axios
 */
export const instance = axios.create({
    baseURL: window.__RUNTIME_CONFIG__.REACT_APP_API_URL,
    timeout: 1800000,
})

interface AdaptAxiosRequestConfig extends AxiosRequestConfig {
    headers: AxiosRequestHeaders
  }

// request interceptor --> add token to the request
/*
instance.interceptors.request.use(function (config) {
    const token = cookies.get("token")
    if (config.headers) {
        config.headers.Authorization = token ? `Bearer ${token}` : ""

        return config
    }
})
    */

// Interceptors
instance.interceptors.request.use(
    (config): AdaptAxiosRequestConfig => {
        const token = cookies.get("token")
        if (config.headers) {
            config.headers.Authorization = token ? `Bearer ${token}` : ""
        }

        // Proactively restore userid if token exists but localStorage.userid is missing
        if (token && !localStorage.getItem('userid')) {
            try {
                const decoded = jwtDecode<JwtPayload>(token);
                const userid = decoded._id;
                if (userid) {
                    localStorage.setItem('userid', userid);
                }
            } catch (decodeError) {
                console.error('Failed to decode JWT token in request interceptor:', decodeError);
            }
        }

        return config;
    },
    (error): any => {
      return Promise.reject(error);
    }
  );

// Add a response interceptor
instance.interceptors.response.use(
    (response) => {
        return response
    },
    async (error) => {
        // get the original request and the refresh_token from the cookies
        const originalRequest = error.config
        const refresh_token = cookies.get("refresh_token")

        // When response code is 401, try to refresh the token.
        if (error.response && error.response.status === 401 && error.config && !error.config.__isRetryRequest) {
            if (!refresh_token) {
                // if the refresh token does not exist logout the user and clear both tokens
                logout() // !!! never remove !!!
                return Promise.reject(error);
            }
            originalRequest._retry = true

            try {
                // axios request (this is not the instance to avoid the interceptor loop if the refresh request is also 401 )
                const response = await axios.post(window.__RUNTIME_CONFIG__.REACT_APP_API_URL + "/auth/refresh", { refresh_token })
                // save the new tokens into cookie
                setCookies(response.data.token, response.data.refreshToken);

                // Restore userid from the new token if missing in localStorage
                if (!localStorage.getItem('userid')) {
                    try {
                        const decoded = jwtDecode<JwtPayload>(response.data.token);
                        const userid = decoded._id;
                        if (userid) {
                            localStorage.setItem('userid', userid);
                        }
                    } catch (decodeError) {
                        console.error('Failed to decode JWT token:', decodeError);
                    }
                }

                // add the new token to the original request
                originalRequest.headers.Authorization = `Bearer ${response.data.token}`
                return axios(originalRequest)
            } catch (error) {
                // if the refresh was unsuccessful logout the user and clear both tokens
                logout() // !!! never remove !!!
            }
        }

        throw error
    }
)

export default instance
